/**
 * Copyright 2021 mmmint.ai info@mmmint.ai - All Rights Reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential to MMM Intelligence UG (haftungsbeschränkt).
 */

import { TpsEnum } from "./third-party-system-type.enum";

/**
 * Creates a report meta document.
 * The meta documents are used to correlate a report with a third party system (e.g. KSR).
 */
export enum ExportReportMetaTypeEnum {
  /**
   * Creates a new KSR job.
   */
  KSR_NEW = "ksrNew",

  /**
   * Adds to an existing KSR job.
   */
  KSR_EXISTING = "ksrExisting",

  /**
   * Adds to an existing DA job.
   */
  DA_EXISTING = "daExisting",

  /**
   * Notify unfallnavi in case customer wishes to get into contact with them
   */
  UNFALLNAVI = "unfallnavi",

  /**
   * Add information to an existing GCS job, reuses `KsrExportReportDto`
   */
  GCS_EXISTING = "gcsExisting"
}

export const ExportReportMetaTypeMap = new Map<ExportReportMetaTypeEnum, string>([
  [ExportReportMetaTypeEnum.KSR_NEW, TpsEnum.KSR],
  [ExportReportMetaTypeEnum.KSR_EXISTING, TpsEnum.KSR],
  [ExportReportMetaTypeEnum.DA_EXISTING, TpsEnum.DA],
  [ExportReportMetaTypeEnum.UNFALLNAVI, "UNFALLNAVI"],
  [ExportReportMetaTypeEnum.GCS_EXISTING, TpsEnum.GCS]
]);
